import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col } from "react-bootstrap";
import profile from "../images/profile.png";
import "../../Pages/CommonStyle.css";
import { getReadableDateYYYYMMDD } from "../../utils/utils";

import TextField from "@mui/material/TextField";
import axios from "axios";

import { toast } from "react-toastify";
import { base_url } from "../../utils/AxiosConfig";
import dayjs from "dayjs";

const EventCreationModal = ({
  showJobCardPopUp,
  closeJobCardModal,
  clickedDateFromCalendar,
  clickedDateFromCalendarFormatted,
  callRefreshEventList,
}) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  let portNumber = localStorage.getItem("BondTimeportNoData");

  let clickedDateFromCalendarReadable = null;

  if (clickedDateFromCalendar) {
    clickedDateFromCalendarReadable = getReadableDateYYYYMMDD(
      clickedDateFromCalendar,
    );
  }

  const [datePickedForStart, setDatePickedForStart] = useState(null);
  const [datePickedForEnd, setDatePickedForEnd] = useState(null);

  // console.log(
  //   "clickedDateFromCalendar datePickedForStart >>",
  //   clickedDateFromCalendar,
  //   datePickedForStart,
  // );

  // console.log("selected Date from Calendarr:", clickedDateFromCalendar);

  const [timePickedForStart, setTimePickedForStart] = useState("09:00");
  const [timePickedForEnd, setTimePickedForEnd] = useState("17:00");

  useEffect(() => {
    console.log("datePickedForStart ", datePickedForStart);
  }, [datePickedForStart]);

  const storedLoginUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeLoginUserData")) || [];

  let eventOwnerIdFromLocal = "";
  let eventOwnerNameFromLocal = "";

  if (storedLoginUserDataArray.length > 0) {
    console.log("storedLoginUserDataArray ", storedLoginUserDataArray);

    eventOwnerIdFromLocal = storedLoginUserDataArray[0].EMPID;
    eventOwnerNameFromLocal = storedLoginUserDataArray[0].salesman_name;
    // setFilterId(storedLoginUserDataArray[0].EMPID)
  }

  console.log("eventOwnerNameFromLocal",eventOwnerNameFromLocal)
  console.log("eventOwnerIdFromLocal",eventOwnerIdFromLocal)

  const today = dayjs().format("YYYY-MM-DD");

  console.log('today:',today)

  const initialObject = {
    cmpcode: companyCode,
    mode: "ENTRY",
    event_id: "DE9ECBC2-F1DF-40F1-BC67-4BD3087978BD",
    event_name: "",
    event_scheduledon: "2024-12-25 17:54:52",
    event_owner_id: "",
    evnt_ownder_name: "",
    event_ownder_dept: "",
    created_on: today,
    evnt_creator_name: eventOwnerNameFromLocal, //FromLocal login  eventOwnerNameFromLocal
    event_creator_id: eventOwnerIdFromLocal, // from local login eventOwnerIdFromLocal
    devicetoken_employee: "",
    devicetoken_admin: "",
    event_status: "",
  };

  const [objectToSend, setObjectToSend] = useState(initialObject);

  const handleChange = (e) => {
    setObjectToSend({ ...objectToSend, [e.target.name]: e.target.value });
  };

  const handleDatePickerDateStart = (e) => {
    setDatePickedForStart(getReadableDateYYYYMMDD(e?.target.value));
    // setDatePickedForStart(dayjs(e.target.value).format("YYYY-MM-DD"));
    // setDatePickedForStart(dayjs(clickedDateFromCalendar).format("YYYY-MM-DD"));

    if (datePickedForEnd) {
      if (datePickedForEnd < getReadableDateYYYYMMDD(e.target.value)) {
        setDatePickedForEnd(getReadableDateYYYYMMDD(e.target.value));
      }
    } else {
      if (
        clickedDateFromCalendarReadable <
        getReadableDateYYYYMMDD(e.target.value)
      ) {
        setDatePickedForEnd(getReadableDateYYYYMMDD(e.target.value));
      }
    }
  };

  const handleDatePickerDateEnd = (e) => {
    console.log(
      "date end start",
      clickedDateFromCalendarReadable,
      datePickedForStart,
    );

    if (datePickedForStart == null) {
      if (
        getReadableDateYYYYMMDD(e.target.value) <
        clickedDateFromCalendarReadable
      ) {
        alert("end date cannot be less than start date");
        setDatePickedForEnd(
          datePickedForEnd ? datePickedForEnd : clickedDateFromCalendarReadable,
        );
        return;
      } else {
        console.log(
          "end date datePickedForStart == null",
          getReadableDateYYYYMMDD(e.target.value),
        );
        setDatePickedForEnd(getReadableDateYYYYMMDD(e.target.value));
      }
    } else {
      if (getReadableDateYYYYMMDD(e.target.value) < datePickedForStart) {
        alert("end date cannot be less than start date");
        setDatePickedForEnd(
          datePickedForEnd ? datePickedForEnd : clickedDateFromCalendarReadable,
        );
        return;
      } else {
        console.log(
          "end date datePickedForStart not null",
          getReadableDateYYYYMMDD(e.target.value),
        );
        setDatePickedForEnd(getReadableDateYYYYMMDD(e.target.value));
      }
    }
  };

  const handleTimePickerDateStart = (e) => {
    setTimePickedForStart(e.target.value);
  };

  const handleTimePickerDateEnd = (e) => {
    setTimePickedForEnd(e.target.value);
  };

  const sendObjectToEventCreationApI = () => {
    if (objectToSend.event_name?.length == 0) {
      alert("Please enter event name");
      return;
    }

    console.log("date start ", datePickedForStart);
    console.log("date end ", datePickedForEnd);
    console.log(
      "clickedDateFromCalendarReadable ",
      clickedDateFromCalendarReadable,
    );
    console.log("time start ", timePickedForStart);
    console.log("time end ", timePickedForEnd + ":00");

    let modifiedObjectToSend = null;

    if (datePickedForStart) {
      modifiedObjectToSend = {
        ...objectToSend,
        event_scheduledon:
          datePickedForStart + " " + timePickedForStart + ":00",
      };
    } else {
      modifiedObjectToSend = {
        ...objectToSend,
        event_scheduledon:
          clickedDateFromCalendarReadable + " " + timePickedForStart + ":00",
      };
    }

    console.log("modifiedObjectToSend ", modifiedObjectToSend);

    const postBody = JSON.stringify([modifiedObjectToSend]);

    let apiUrl = `${base_url}/api/CRMEvents`;
    console.log("apiurl ", apiUrl);

    axios
      .post(apiUrl, postBody, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Event Saved!");
          callRefreshEventList();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <Modal show={showJobCardPopUp} onHide={closeJobCardModal} centered>
      <Modal.Header closeButton className="border-b ">
        <h2 className="text-lg font-semibold text-gray-800 ">Create Event</h2>
      </Modal.Header>

      <Modal.Body className="bg-gray-50">
        <div className="space-y-5">
          {/* Event Name */}
          <div className="flex flex-col">
            <label className="text-sm text-gray-600 mb-1">Event Name</label>
            <input
              type="text"
              name="event_name"
              onChange={(e) => handleChange(e)}
              placeholder="Enter event name"
              className="px-3 py-2 rounded-md border border-gray-300 
                     focus:outline-none focus:ring-2 focus:ring-blue-500 
                     focus:border-blue-500 bg-white text-sm"
            />
          </div>

          {/* Start Date & Time */}
          {clickedDateFromCalendar && (
            <div className="flex flex-col">
              <label className="text-sm text-gray-600 mb-2">
                Start Date & Time
              </label>

              <div className="flex gap-3">
                {/* Date */}
                <input
                  // type="date"
                  disabled={true}
                  defaultValue={clickedDateFromCalendarReadable}
                  min={clickedDateFromCalendarReadable}
                  // value={dayjs(clickedDateFromCalendar).format("YYYY-MM-DD")}
                  value={datePickedForStart}
                  // value={clickedDateFromCalendarFormatted}
                  onChange={(e) => handleDatePickerDateStart(e.target.value)}
                  className=" cursor-not-allowed text-center flex-1 px-1 py-2 rounded-md border border-gray-100 
                         focus:outline-none focus:ring-2 focus:ring-blue-500 
                         focus:border-blue-500 bg-white text-sm font-semibold"
                />

                {/* Time */}
                <input
                  type="time"
                  value={timePickedForStart}
                  onChange={(e) => handleTimePickerDateStart(e)}
                  className="flex-1 px-3 py-2 rounded-md border border-gray-300 
                         focus:outline-none focus:ring-2 focus:ring-blue-500 
                         focus:border-blue-500 bg-white text-sm"
                />
              </div>
            </div>
          )}

          {/* Action Button */}
          <div className="pt-4">
            <button
              onClick={sendObjectToEventCreationApI}
              className="w-full bg-blue-600 hover:bg-blue-700 
                     text-white text-sm font-medium 
                     py-2.5 rounded-md shadow-sm 
                     transition-all duration-200 
                     focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              Save Event
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EventCreationModal;
